// https://css-tricks.com/building-progress-ring-quickly/

<template>
  <div class="start-content-container" id="circular-progress">
    <svg class="circle" :height="(radius + stroke) * 2" :width="(radius + stroke) * 2">
      <circle
        class="progress-background"
        stroke="#fff"
        fill="transparent"
        :stroke-width="stroke"
        :r="radius"
        :cx="radius + stroke"
        :cy="radius + stroke"
      />
      <circle
        class="progress"
        stroke="#E87722"
        fill="transparent"
        :stroke-dasharray="circumference + ' ' + circumference"
        :style="{ strokeDashoffset }"
        :stroke-width="stroke"
        :r="radius"
        :cx="radius + stroke"
        :cy="radius + stroke"
      />
      <text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="#fff">{{ progress }}%</text>
    </svg>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import VitalsConfig from "../../plugin/plugin_configuration.js";
import { ref } from "vue";

export default {
  setup() {
    const { t, locale } = useI18n();
    return {
      t,
      locale,
      progress: ref(0),
    };
  },
  props: {
    timeLeft: { type: Number, default: undefined },
    text: String,
  },
  data() {
    const radius = 72.5;
    const stroke = 14.5;
    const circumference = radius * 2 * Math.PI;

    return {
      circumference,
      width: window.innerWidth,
      radius,
      stroke,
    };
  },
  methods: {
    resizeAdjustment() {
      if (window.innerWidth < 767) {
        this.radius = 40;
        this.stroke = 8;
      } else {
        this.radius = 72.5;
        this.stroke = 14.5;
      }
    },
  },
  created() {
    this.totalTime = VitalsConfig.Plugin.scanTime;
  },
  computed: {
    strokeDashoffset() {
      return this.circumference - (this.progress / 100) * this.circumference;
    },
  },
  watch: {
    timeLeft(newValue) {
      if (newValue === null) {
        this.progress = 0;
      } else {
        this.progress = Math.round(((this.totalTime - this.timeLeft) / this.totalTime) * 100.0);
      }
    },
  },
  mounted() {
    this.resizeAdjustment();
    this.$nextTick(() => {
      window.addEventListener("resize", this.resizeAdjustment);
    });
  }
};
</script>

<style scoped>
#circular-progress {
  justify-content: flex-end;
}
.d-flex {
  gap: 80px;
}
.progress {
  transition: stroke-dashoffset 0.35s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}
text {
  font-size: 80px;
  color: #ffffff !important;
}
/* p {
    position: relative;
    left: -50%;
    transform: translate(0%, -50%);
    font-size: 1.5em;
    color: white;
} */

@keyframes textAnimation {
  0% {
    opacity: 1;
    font-size: 1.2em;
    content: var(--in);
  }
  45% {
    opacity: 1;
    font-size: 2.9em;
    content: var(--in);
  }
  46% {
    opacity: 1;
    font-size: 2.9em;
    content: var(--out);
  }
  90% {
    opacity: 1;
    font-size: 1.2em;
    content: var(--out);
  }
  91% {
    opacity: 1;
    font-size: 1.2em;
    content: var(--in);
  }
  100% {
    opacity: 1;
    font-size: 1.2em;
    content: var(--in);
  }
}
@keyframes textAnimation-mobile {
  0% {
    opacity: 1;
    font-size: 1em;
    content: var(--in);
  }
  45% {
    opacity: 1;
    font-size: 1.5em;
    content: var(--in);
  }
  46% {
    opacity: 1;
    font-size: 1.5em;
    content: var(--out);
  }
  90% {
    opacity: 1;
    font-size: 1em;
    content: var(--out);
  }
  91% {
    opacity: 1;
    font-size: 1em;
    content: var(--in);
  }
  100% {
    opacity: 1;
    font-size: 1em;
    content: var(--in);
  }
}
@keyframes circleAnimation {
  0% {
    opacity: 0.75;
    fill: #ffaa00;
    transform: scale(0.4);
  }
  50% {
    opacity: 0.9;
    fill: #00cc00;
    transform: scale(1);
  }
  100% {
    opacity: 0.75;
    fill: #ffaa00;
    transform: scale(0.4);
  }
}
@keyframes circleAnimation-mobile {
  0% {
    opacity: 0.75;
    fill: #ffaa00;
    transform: scale(0.3);
  }
  50% {
    opacity: 0.9;
    fill: #00cc00;
    transform: scale(0.9);
  }
  100% {
    opacity: 0.75;
    fill: #ffaa00;
    transform: scale(0.3);
  }
}

.breathing-circle-animation {
  opacity: 1;
  position: relative;
  left: 50%;
  top: 50%;
  color: white;
}

@media (max-width: 1023px) {
  .d-flex {
    gap: 10px;
  }
  text {
    font-size: 40px;
  }
}

@media (max-width: 767px) {
  text {
    font-size: 25px;
  }
  #circular-progress {
    bottom: 40px;
  }
}
</style>
